import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getEmployeeDesignations,
  getEmployeeDesignation,
  createEmployeeDesignation,
  editEmployeeDesignation,
  deleteEmployeeDesignation,
  getAllEmployeeDesignations,
  getTrashedEmployeeDesignations,
  restoreEmployeeDesignation,
} from "api/employeeDesignationApi"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const EMPLOYEE_DESIGNATION_QUERY_KEY = "employee-designations"

export const useEmployeeDesignations = (params = {}, enabled = true) => {
  return usePaginatedResource(
    EMPLOYEE_DESIGNATION_QUERY_KEY,
    getEmployeeDesignations,
    params,
    enabled
  )
}

export const useEmployeeDesignation = (id, enabled = true) => {
  return useResourceItem(
    EMPLOYEE_DESIGNATION_QUERY_KEY,
    getEmployeeDesignation,
    id,
    enabled
  )
}

export const useCreateEmployeeDesignation = () => {
  return useCreateResource(
    createEmployeeDesignation,
    EMPLOYEE_DESIGNATION_QUERY_KEY
  )
}

export const useEditEmployeeDesignation = () => {
  return useEditResource(
    editEmployeeDesignation,
    EMPLOYEE_DESIGNATION_QUERY_KEY
  )
}

export const useDeleteEmployeeDesignation = () => {
  return useDeleteResource(
    deleteEmployeeDesignation,
    EMPLOYEE_DESIGNATION_QUERY_KEY
  )
}

export const useAllEmployeeDesignations = (params = {}) => {
  return usePaginatedResource(
    EMPLOYEE_DESIGNATION_QUERY_KEY,
    getAllEmployeeDesignations,
    { ...params, all: true },
    true
  )
}

export const useTrashedEmployeeDesignations = (params = {}) => {
  return usePaginatedResource(
    EMPLOYEE_DESIGNATION_QUERY_KEY,
    getTrashedEmployeeDesignations,
    params,
    true
  )
}

export const useRestoreEmployeeDesignation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreEmployeeDesignation,
    onSuccess: (res, { id }) => {
      const restoredItem = res?.data
      if (!restoredItem) return

      queryClient.setQueriesData([EMPLOYEE_DESIGNATION_QUERY_KEY, "all"], old => {
        if (!old || !old.data || !Array.isArray(old.data.data)) return old
        const updated = structuredClone(old)
        updated.data.data = [restoredItem, ...updated.data.data]
        updated.data.total = (updated.data.total || 0) + 1
        return updated
      })

      queryClient.setQueryData([EMPLOYEE_DESIGNATION_QUERY_KEY, id], restoredItem)
    },
  })
}
